import axios from 'axios'
import IMask from 'imask'
import { ISubcategory } from 'safe'
import { deleteToS3, uploadToS3 } from '../../utils/UploadFile'
import { formatPipe } from '../../utils/utils'
import { IAssociateCode } from './AssociatedCode'
import { IComposition } from './Compound'
import { ICost, IPrice } from './PriceAndCost'
import { IBatch } from './Rotation'
import { IUnit } from './Units'

const server = process.env.REACT_APP_SERVER_URL

export const fetchItems = async (
  querySearch: string[] = [],
  paginationParams: string[],
  evaluate = 'none'
): Promise<IITemsResponse> => {
  try {
    const response = await axios.get<IITemsResponse>(
      `${server}/inventory/item?${[...querySearch, ...paginationParams].join(
        '&'
      )}`
    )
    return response?.data
  } catch (error) {
    throw error
  }
}

export const createItem = async (
  item: ICreateITemDTO,
  hasImage: boolean,
  fd: FormData,
  image?,
  tenantId?: string
): Promise<any> => {
  let newItem: IItem

  try {
    let s3InfoResponse: { value: any } = { value: {} }
    if (image && tenantId) {
      console.log('image...', image)
      /** Se pasa como referencia para modificar el objeto actual y tenerlo como una especie de promesa */
      await uploadToS3(image, s3InfoResponse, undefined, tenantId)
      console.log('responseeee', s3InfoResponse)
    }

    // let mask = IMask(item?.cost, {
    //   mask: Number,
    //   thousandsSeparator: '.',
    //   radix: ',',
    //   scale: 2,
    //   normalizeZeros: true,
    //   padFractionalZeros: true,
    // })

    const response = await axios.post<any>(`${server}/inventory/item`, {
      ...item,
      cost: formatPipe(item.cost, true),
      price: formatPipe(item.price, true),
      image:
        image && tenantId
          ? `https://${s3InfoResponse.value.Bucket}.s3.amazonaws.com/${s3InfoResponse.value.Key}`
          : '',
    })

    return response

    // console.log("e", err)

    // newItem = response.data.newItem
    // if (hasImage) {
    //   const response2 = await axios.put<IUploadImageDTO>(
    //     `${server}/media/file?idEntity=${newItem.id}&entity=item`,
    //     fd
    //   )
    //   const image = {
    //     id: response2.data.id,
    //     url: response2.data.file,
    //   }
    //   newItem.images[0] = image
    // }
  } catch (error) {
    console.log('ERR', error)
    throw error
  }
  // return newItem
}

export const updateItem = async (
  item: any,
  image?,
  oldImage?: string,
  tenantId?: string
): Promise<IItem> => {
  try {
    console.log('image to delete', item.imageToDelete)
    console.log('tenantId', tenantId)
    if (item.imageToDelete) {
      await deleteToS3(item.imageToDelete)
    }

    let s3InfoResponse: { value: any } = { value: {} }
    if (image) {
      console.log('image...', image)
      console.log('item...', oldImage)

      /** Se pasa como referencia para modificar el objeto actual y tenerlo como una especie de promesa */
      await uploadToS3(image, s3InfoResponse, oldImage)
      console.log('responseeee', s3InfoResponse)
    }

    const response = await axios.patch<IUpdateITemResponseDTO>(
      `${server}/inventory/item`,
      {
        ...item,
        cost: formatPipe(item.cost, true),
        price: formatPipe(item.price, true),
        image: item.imageToDelete
          ? ''
          : image && tenantId
          ? `https://${s3InfoResponse.value.Bucket}.s3.amazonaws.com/${s3InfoResponse.value.Key}`
          : oldImage,
      }
    )
    const updatedItem = response.data.updatedItem
    // if (hasImage) {
    //   const response2 = await axios.put<IUploadImageDTO>(
    //     `${server}/media/file?idEntity=${updatedItem.id}&entity=item`,
    //     fd
    //   )
    //   const image = {
    //     id: response2.data.id,
    //     url: response2.data.file,
    //   }
    //   updatedItem.images[0] = image
    // }
    // if (item.imageToDelete) {
    //   axios.put<any>(
    //     `${server}/media/delete-file?idEntity=${item.imageToDelete.id}&entity=item`,
    //     {
    //       data: { originalname: item.imageToDelete.url },
    //     }
    //   )
    //   updatedItem.images = []

    return updatedItem
  } catch (error) {
    console.log('vemos error', error)
    throw error
  }
}

export const removeItem = async (itemId: string): Promise<void> => {
  try {
    const response = await axios.delete<IDeleteItemResponseDTO>(
      `${server}/inventory/item?id=${itemId}`
    )
    return
  } catch (error) {
    console.log('error', error)
    throw error
  }
}

export interface IITemsResponse {
  items: IItem[]
  numberOfPages: number
  status: number
}

export interface ICreateITemDTO {
  barcode: string | null
  sku: string | null
  brand: string
  category: { id: string }
  description: string
  exempt: boolean
  imageToDelete: {
    id: string
    url: string
  }
  cost: string
  price: string
  name: string
  subcategory: { id: string }
  type: ItemType
  unit: { id: string }
  currency: { id: string }
  image?: string | undefined | Blob
  ivaType?: string
}

export interface IUpdateItemDTO extends ICreateITemDTO {
  id: string
}

interface ICreateItemResponseDTO {
  message: string
  newItem: IItem
  status: number
}

interface IUploadImageDTO {
  status: number
  id: string
  file: string
}

interface IUpdateITemResponseDTO {
  message: string
  status: number
  updatedItem: IItem
}

interface IDeleteItemResponseDTO {
  status: number
  message: string
  deletedItem: IItem
}

export interface IItem {
  id: string
  name: string
  description: string
  category: ISubcategory
  sku: string | null
  barcode: string | null
  exempt: boolean
  compound: boolean
  imageToDelete?: any
  brand: string
  providers: any
  subcategory: any
  images: {
    url: string
  }[]
  associatedCode: IAssociateCode[]
  composition: IComposition[]
  compositionCompound?: {
    amount: string
    compound_item: { id: string }
    id: string
    item: IItem
  }[]
  cost: ICost[]
  price: IPrice[]
  unit: IUnit
  batch: IBatch[]
  assembly: any[]
  type: ItemType
  inCatalog: boolean
  locationAndQuantity?: {
    date: string
    description: string
    id_existence: string
    id_item: string
    id_store: string
    id_warehouse: string
    name: string
    quantity: string
    tenant_id: string
    warehouse_type: string
  }[]
}

export type ItemType = 'COMPOUND' | 'ASSEMBLY' | 'PRODUCTION' | 'NORMAL'
